import CheckInTemplateSection from './CheckInTemplateSection';

export default CheckInTemplateSection;
